var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"header-bar"},[_c('div',{staticClass:"home-box",on:{"click":_vm.toHome}},[_c('Icon',{attrs:{"size":25,"type":"md-home"}})],1),_c('div',{staticClass:"custom-content-con"},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }